export default {
    MANUAL: 1,
    AUTOMATICO: 2,
}